import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { popuplar } from "@/mocks/dashboard";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";
const RENKLER = ["#f59e0b", "#10b981", "#ec4899", "#8b5cf6"];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: "#1e2130", border: "1px solid #2a2d3a", borderRadius: 12, padding: "10px 14px" }}>
        <p style={{ fontSize: 11, fontWeight: 600, color: "#8b8fa8", marginBottom: 4 }}>{label}</p>
        <p style={{ fontSize: 11, color: "#a78bfa" }}>Dönüşüm: <strong>%{payload[0].value}</strong></p>
      </div>
    );
  }
  return null;
};

export default function PopupPerformansi() {
  const grafikData = popuplar.map((p) => ({ ad: p.ad.split(" ").slice(0, 2).join(" "), donusum: p.donusumOrani }));

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>Teklif / Popup Performansı</h2>
        <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Popup gösterim ve dönüşüm analizi</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { label: "Toplam Gösterim", deger: popuplar.reduce((s, p) => s + p.gosterim, 0).toLocaleString("tr-TR"), ikon: "ri-eye-line", accent: "#7c3aed", bg: "rgba(124,58,237,0.15)" },
          { label: "Toplam Form Dolduran", deger: popuplar.reduce((s, p) => s + p.formDolduran, 0).toLocaleString("tr-TR"), ikon: "ri-file-edit-line", accent: "#10b981", bg: "rgba(16,185,129,0.15)" },
          { label: "Ort. Dönüşüm Oranı", deger: `%${(popuplar.reduce((s, p) => s + p.donusumOrani, 0) / popuplar.length).toFixed(1)}`, ikon: "ri-percent-line", accent: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
        ].map((item, i) => (
          <div key={i} className="rounded-2xl p-4 flex items-center gap-4" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: item.bg }}>
              <i className={`${item.ikon} text-lg`} style={{ color: item.accent }}></i>
            </div>
            <div>
              <p className="text-xl font-bold" style={{ color: TEXT_PRIMARY }}>{item.deger}</p>
              <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {popuplar.map((popup, i) => (
          <div key={popup.id} className="rounded-2xl p-5 transition-all duration-200" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: RENKLER[i % RENKLER.length] }}>
                  <i className="ri-notification-3-line text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-bold" style={{ color: TEXT_PRIMARY }}>{popup.ad}</p>
                  <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{popup.kampanya}</p>
                </div>
              </div>
              <span className="text-xs font-bold px-2.5 py-1 rounded-full" style={{ backgroundColor: RENKLER[i % RENKLER.length] + "25", color: RENKLER[i % RENKLER.length] }}>%{popup.donusumOrani}</span>
            </div>
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div className="rounded-xl p-3" style={{ backgroundColor: "#0d0f16" }}>
                <p className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>{popup.gosterim.toLocaleString("tr-TR")}</p>
                <p className="text-xs" style={{ color: TEXT_SECONDARY }}>Gösterim</p>
              </div>
              <div className="rounded-xl p-3" style={{ backgroundColor: "#0d0f16" }}>
                <p className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>{popup.formDolduran.toLocaleString("tr-TR")}</p>
                <p className="text-xs" style={{ color: TEXT_SECONDARY }}>Form Dolduran</p>
              </div>
            </div>
            <div className="mb-4">
              <div className="flex items-center justify-between mb-1.5">
                <p className="text-xs" style={{ color: TEXT_SECONDARY }}>Dönüşüm Oranı</p>
                <p className="text-xs font-semibold" style={{ color: "#c8cad8" }}>%{popup.donusumOrani}</p>
              </div>
              <div className="h-2 rounded-full overflow-hidden" style={{ backgroundColor: "#1e2130" }}>
                <div className="h-full rounded-full transition-all duration-700" style={{ width: `${popup.donusumOrani}%`, backgroundColor: RENKLER[i % RENKLER.length] }}></div>
              </div>
            </div>
            <div className="rounded-xl p-3 text-xs font-medium" style={{ backgroundColor: RENKLER[i % RENKLER.length] + "15", color: RENKLER[i % RENKLER.length] }}>
              <i className="ri-lightbulb-line mr-1"></i>{popup.insight}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl p-5" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <h3 className="text-sm font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Popup Dönüşüm Karşılaştırması</h3>
        <p className="text-xs mb-5" style={{ color: TEXT_SECONDARY }}>Tüm popupların dönüşüm oranları</p>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={grafikData} layout="vertical" margin={{ top: 0, right: 20, left: 10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1e2130" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 11, fill: "#3a3d4a" }} axisLine={false} tickLine={false} unit="%" />
            <YAxis type="category" dataKey="ad" tick={{ fontSize: 11, fill: "#5a5f7a" }} axisLine={false} tickLine={false} width={100} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="donusum" radius={[0, 4, 4, 0]}>
              {grafikData.map((_, index) => <Cell key={index} fill={RENKLER[index % RENKLER.length]} opacity={0.85} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
